import { Box, styled, Typography } from '@mui/material'
import { FC } from 'react'

import TrainingCompleted from '@/assets/images/training-completed.svg'
import CywarenessDefaultImage from '@/assets/images/cywareness_default.png'
import { DeviceType } from '@/common/hooks/useDeviceDetection'
import { theme } from '@/theme/theme'
import { Video } from '@/types/videos'
import { faCheck } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import dayjs from 'dayjs'

type VideoCardParams = {
  video: Video
  handleVideoClick: (id: string) => void
  isCurrentVideo?: boolean
  deviceType?: DeviceType
}

const VideoCard: FC<VideoCardParams> = ({ video, handleVideoClick, isCurrentVideo, deviceType }) => {
  return (
    <Box key={video.id} flex={1} onClick={() => handleVideoClick(video.id)} width={344}>
      <Box style={{ position: 'relative', marginRight: theme.spacing(2) }}>
        <img
          src={video.thumbnail || CywarenessDefaultImage}
          alt={video.title}
          style={{
            width: '100%',
            height: '200px',
            marginRight: theme.spacing(1),
            border: isCurrentVideo ? `4px solid ${theme.palette.green[500]}` : '1px solid black',
            borderRadius: '16px',
            cursor: 'pointer',
          }}
        />
        {video.completed && (
          <img
            src={TrainingCompleted}
            alt="Training Completed"
            style={{
              cursor: 'pointer',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        )}
        <StyledTimeWrapper deviceType={deviceType}>
          {dayjs().startOf('day').add(video.duration, 'second').format('mm:ss')}
        </StyledTimeWrapper>
      </Box>
      {isCurrentVideo && (
        <StyledCurrentVideoIndicator>
          <FontAwesomeIcon icon={faCheck} />
          <Typography fontWeight={theme.typography.fontWeightMedium}>Current</Typography>
        </StyledCurrentVideoIndicator>
      )}
      <Typography variant="subtitle1" m={theme.spacing(1, 2)} fontWeight={theme.typography.fontWeightMedium}>
        {video.title}
      </Typography>
    </Box>
  )
}

const StyledTimeWrapper = styled(Box)(({ deviceType }: { deviceType?: DeviceType }) => ({
  background: theme.palette.black + 90,
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.spacing(1),
  color: theme.palette.common.white,
  position: 'absolute',
  right: theme.spacing(1),
  bottom: theme.spacing(deviceType === DeviceType.Mobile ? 2 : 1),
  fontWeight: theme.typography.fontWeightMedium,
}))

const StyledCurrentVideoIndicator = styled(Box)({
  position: 'absolute',
  marginLeft: theme.spacing(13),
  top: theme.spacing(-1.5),
  border: `3px solid ${theme.palette.green[500]}`,
  borderRadius: '8px',
  padding: theme.spacing(0, 2),
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.white,
  gap: theme.spacing(1),
})

export default VideoCard
